import { useEffect, useState } from "react";
import { supabase, isStaffSession } from "@/lib/supabase";

/** True wanneer de huidige sessie het gedeelde medewerker-account is (afgeslankte weergave). */
export function useIsStaff(): boolean {
  const [staff, setStaff] = useState(false);
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setStaff(isStaffSession(data.session)));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setStaff(isStaffSession(s)));
    return () => sub.subscription.unsubscribe();
  }, []);
  return staff;
}
